import { render, staticRenderFns } from "./DeviceZabbixDialogStatus.vue?vue&type=template&id=4df79ba5&scoped=true&"
import script from "./DeviceZabbixDialogStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceZabbixDialogStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeviceZabbixDialogStatus.vue?vue&type=style&index=0&id=4df79ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df79ba5",
  null
  
)

export default component.exports